import { render, staticRenderFns } from "./FormSignUp.vue?vue&type=template&id=1337c51e&lang=pug"
import script from "./FormSignUp.vue?vue&type=script&lang=js"
export * from "./FormSignUp.vue?vue&type=script&lang=js"
import style0 from "./FormSignUp.vue?vue&type=style&index=0&id=1337c51e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports